import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import { VIPStore } from '@/utils/store/vip';
import axios from 'axios';
import dayjs from 'dayjs';
import { ERROR_MESSAGES } from '@/constants/messages';
import { createPayment, addOrderTest } from '@/services/api';
import { handleError } from '@/utils/helpers';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';

interface Props {}

const PriceCard = ({title, desc}) => {

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const isDebug = query.get("isDebug");

    // 使用 Supabase 认证状态替代 Auth0
    const supabaseAuth = useSnapshot(supabaseAuthStore);
    // const { user: auth0User, isAuthenticated: auth0IsAuthenticated, isLoading: isAuth0Loading, logout, loginWithRedirect } = useAuth0();
    
    // 优先使用 Supabase 认证，如果没有则回退到 Auth0
    const user = supabaseAuth.user ;
    const isAuthenticated = supabaseAuth.isAuthenticated ;
    const isLoading = supabaseAuth.isLoading ;
    
    const { data, runFetch } = useSnapshot(VIPStore);
    console.log(20, data);

  return (
    <>
        <div className="card  border-1 w-full ">
            <div className="card-body p-6">
                {/*<div className={"bg-black text-white"}>新用户专享价</div>*/}
                <div className="badge badge-neutral rounded-xl p-2">新用户专享价</div>
                <div className="m-5">
                    <span className={"flex justify-center items-center "}><div className={"font-bold text-[36px]"}>¥?</div><div> /月</div></span>
                    <div className={"text-center  line-through text-[#6B7280]"}>原价 ¥??</div>
                </div>
                <div className="m-2">
                    <div className={"flex gap-2 pt-2"}>
                        <CheckOutlined  style={{color: "#34D399" ,fontSize: "16px"}}/>
                        <div className={"text-[#4B5563]"}>每月?小时转写</div>
                    </div>
                    <div className={"flex gap-2 pt-2"}>
                        <CheckOutlined  style={{color: "#34D399" ,fontSize: "16px"}}/>
                        <div className={"text-[#4B5563]"}>AI整理</div>
                    </div>
                    <div className={"flex gap-2 pt-2"}>
                        <CheckOutlined  style={{color: "#34D399" ,fontSize: "16px"}}/>
                        <div className={"text-[#4B5563]"}>导出</div>
                    </div>
                </div>
                <div className={"flex gap-2 m-2"}>
                    <input type="checkbox" defaultChecked className="checkbox" />
                    <div>
                        <div className={"text-sm text-[#4B5563]"}>同意自动续费协议</div>
                        <div className={"text-xs text-[#6B7280]"}>次月起按¥??/月续费</div>
                    </div>
                </div>
                <button className="btn btn-neutral w-full m-2"
                onClick={async ()=>{
                    if(isDebug){

                        // 如果登录了，保存历史
                        if(isAuthenticated && !isLoading){
                             try {
                                const response = await addOrderTest({
                                    userId: supabaseAuth.id,
                                    createTime: dayjs().unix(),
                                    payAmount: 0.0
                                    // ,result: JSON.stringify({ default:sseStore.data })
                                    // ,input: JSON.stringify(params)
                                });
                                console.log(62, response.data);

                                if (response.data.success) {
                                    runFetch(supabaseAuth.id)
                                } else {
                                    handleError(new Error(response.data.data.message), ERROR_MESSAGES.PAYMENT_CREATION_FAILED);
                                }
                            } catch (error) {
                                handleError(error, ERROR_MESSAGES.PAYMENT_CREATION_FAILED);
                            }
                        }

                    }
                    else {
                        console.log("is not d")
                    }
                }
                }
                >立即续费</button>


            </div>
        </div>
    </>
  )
}

export default PriceCard
